import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import xmark from "../../Images/_xmark.png";
import plus from "../../Images/plus.png";
import "../CSS/faq.css";
import { CardContent, Stack } from "@mui/material";
import { Card, Typography } from "@material-ui/core";
import { useGetAPIWithoutTokenQuery } from "../../Api/api";
import { READ_ALL_FAQ } from "../../Api/apiConstant";
import { useThemeColors } from "../../Context/Theme";
import { BLACK } from "../../styles/color";

const StyledAccordion = styled(Accordion)({
  margin: "0px",
  borderBottom: "1px solid #E7E7E7 !important",
  boxShadow: "none !important",
  "&:before": {
    display: "none",
  },
});
const StyledAccordionSummary = styled(AccordionSummary)({
  "& .MuiAccordionSummary-content": {
    display: "flex",
    alignItems: "center",

    width: "100%",
  },
});


export default function Faq({ isAtAllEvents, id }) {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const event_id = sessionStorage.getItem("event_id");
  const { data } = useGetAPIWithoutTokenQuery(event_id && !isAtAllEvents ? `${READ_ALL_FAQ}?event_id=${event_id}` : `${READ_ALL_FAQ}`, { refetchOnMountOrArgChange: true });


  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleIconClick = (panel) => (event) => {
    event.stopPropagation();
    setExpanded(expanded === panel ? false : panel);
  };

  return (
    <div id={isAtAllEvents ? id : ""} style={{ backgroundColor: isAtAllEvents ? "#FAFAFA" : backgroundColor || "#FAFAFA" }}>
      <div
        className="text-center p-0 fo_css_event_faq"
        style={{
          minHeight: "40vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          width: "91.6%",
          margin: "0 auto"
        }}
      >
        <p style={{ fontSize: fontSizeHeading || "30px", fontWeight: fontWeightHeading || "700", marginTop: "1vh", color: textColor || BLACK, fontFamily: fontFamilyHeading }}>
          Frequently Asked Questions
        </p>
        <Card elevation={0}
          className="fo_css_event_faq_card"
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            marginTop: "2vh",
            width: "100%",
            padding: "20px 20px",
            border: "1px solid #E7E7E7",
            borderRadius: "40px",
            textAlign: "left",
          }}>
          <CardContent className="fo_css_event_faq_card_content">
            {/* <Accordion> */}
            {
              isAtAllEvents
                ? data?.data?.rows?.map((faq, index) => (
                  <Typography
                    className="faq-text"
                    style={{ fontSize: fontSize || "16px", fontFamily }}
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html:
                        `<style>
                          * {
                            font-family: ${fontFamily};
                          }
                        </style>${faq.description}`
                    }}
                  />
                ))
                : data?.data?.map((faq, index) => (
                  <Typography
                    className="faq-text"
                    style={{ fontSize: fontSize || "16px", fontFamily }}
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html:
                        `<style>
                          * {
                            font-family: ${fontFamily};
                          }
                        </style>${faq.description}`
                    }}
                  />
                ))
            }

            {/* </Accordion> */}
          </CardContent>
        </Card>
      </div>

    </div>
  );
}